/**
 * Admin User Management Route
 * Requires admin role to access
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserManagement } from '../../pages/Admin/UserManagement';

export const Route = createFileRoute('/_authenticated/admin/users')({
  beforeLoad: ({ context }) => {
    // Check if user is admin
    const user = (context as any)?.user;
    if (user && user.role !== 'admin') {
      throw redirect({
        to: '/home',
      });
    }
  },
  component: UserManagement,
});
